module.exports = __webpack_public_path__ + "img/cn-home-button.51b6a43e.png";